export default __webpack_public_path__ + "static/media/example-bupa-IMG.789ffb97.jpg";